import React, { useEffect, useState } from 'react';
import NxtbnDrawer from '../drawer';
import useApi from '../../api';
import { useDeleteConfirmation } from '../common';
import { handleRetriveError } from '../../utils';
import UserChangePasswordForm from './create/userPasswordChangeForm';
import UseEditForm from './create/useEditForm';

interface UserDetailsProps {
    isOpen: boolean;
    onClose: () => void;
    id: any;
    onDeactivate: () => void; // Callback for the deactivate action
}

function UserDetails({ isOpen, onClose, id, onDeactivate }: UserDetailsProps) {
    const [user, setUser] = useState<any>(null);
    const api = useApi();
    const [passwordChange, setPasswordChange] = useState<any>(null);
    const [edit, setEdit] = useState<any>(null);

    const {handleDelete} = useDeleteConfirmation()
        
    const handleDeactivate = () => {
        handleDelete(
            id,
            "User",
            api.deactivateUser,
            onDeactivate
        );
    };

    useEffect(() => {
        api.getUserDetails(id).then((response: any) =>  {
            setUser(response);
        }, handleRetriveError);
    }, [id]);

    return (
        <NxtbnDrawer size='md' title='User Details' isOpen={isOpen} onClose={onClose}>
            <div>
                <div className='flex justify-center'>
                    <img
                        src={user?.avatar}
                        alt={user?.username}
                        className='w-[170px] h-[170px] aspect-square object-cover rounded-full'
                    />
                </div>
                <div className="border rounded-lg shadow-lg p-4 mt-6 flex flex-col gap-2">
                    <div>
                        <strong>#Id: {user?.id} </strong>
                    </div>
                    <div>
                        <strong>First name: </strong>{user?.first_name}
                    </div>
                    <div>
                        <strong>Last name: </strong>{user?.last_name}
                    </div>
                    <div>
                        <strong>Username: </strong>{user?.username}
                    </div>
                    <div>
                        <strong>Email: </strong>{user?.email}
                    </div>
                    <div>
                        <strong>Phone Number: </strong>{user?.phone_number}
                    </div>
                    <div>
                        <strong>Role: </strong>{user?.role}
                    </div>

                    <div>
                        <strong>Is Store Admin: </strong>{user?.is_store_admin ? 'Yes' : 'No'}
                    </div>
                    <div>
                        <strong>Is Store Staff: </strong>{user?.is_store_staff ? 'Yes' : 'No'}
                    </div>

                </div>
                {/* Deactivate Button */}
                <div className="mt-6 flex gap-4">
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded-lg w-full hover:bg-blue-600"
                        onClick={() => setEdit(user.id)}
                    >
                        Edit Profile
                    </button>
                    <button
                        className="bg-yellow-500 text-white px-4 py-2 rounded-lg w-full hover:bg-yellow-600"
                        onClick={() => setPasswordChange(user?.id)}
                    >
                        Change Password
                    </button>
                    <button
                        className="bg-red-500 text-white px-4 py-2 rounded-lg w-full hover:bg-red-600"
                        onClick={handleDeactivate}
                    >
                        Deactivate
                    </button>
                </div>
            </div>

            {passwordChange && ( <UserChangePasswordForm isOpen={passwordChange ? true : false} onClose={() => setPasswordChange(null)} userId={passwordChange} /> )}

            {edit && ( <UseEditForm isOpen={edit ? true : false} onClose={() => setEdit(null)} edit={edit} /> )}
        </NxtbnDrawer>
    );
}

export default UserDetails;